/* Momavo photo cart: instant Add to cart for photo products (uses momavo-instant-upload.js).
   - Every <input type="file" data-mo-photo data-mo-prop="Kid's Photo"> uploads the moment a photo is
     picked. Its box (the <label> around it, or label[for=id]) gets data-mo-state = uploading | done |
     error, a small badge and a progress bar (inside its [data-mo-badge] part, if any): "Uploading 45%" with a
     bar that fills with the real upload progress, then a check mark, or "Upload failed, tap to retry".
   - The file inputs have no name, so no file is ever sent to the cart. The photo URL goes in the cart
     line as a text property with the input's data-mo-prop name.
   MomavoPhotoCart.single(form)       Add to cart for a product form: JSON /cart/add.js, opens the cart drawer
   MomavoPhotoCart.finish(inputs, cb) -> Promise<url[]>, waits for (or retries once) each photo upload
   MomavoPhotoCart.thumbs(inputs)     -> Promise<(url|null)[]>, 96 px copies for the cart; put each in
                                         properties[MomavoPhotoCart.thumbKey(prop)] ("_Kid's Photo thumb")
   MomavoPhotoCart.add(items, cart)   -> Promise<response>, one JSON /cart/add.js call for all items */
(function () {
  if (window.MomavoPhotoCart) return;
  var css = '[data-mo-state],[data-mo-badge]{position:relative}' +
    '.mo-up{position:absolute;left:50%;top:50%;z-index:3;transform:translate(-50%,-50%);display:inline-flex;align-items:center;justify-content:center;gap:6px;width:max-content;max-width:94%;padding:6px 10px;border-radius:999px;background:rgba(15,27,51,.86);color:#fff;font-family:inherit;font-size:12px;font-weight:700;line-height:1.2;text-align:center;pointer-events:none}' +
    '.mo-up i{flex:0 0 12px;width:12px;height:12px;border:2px solid rgba(255,255,255,.35);border-top-color:#fff;border-radius:50%;animation:mo-spin .8s linear infinite}' +
    '[data-mo-state=uploading] .mo-up{flex-direction:column;gap:2px;border-radius:12px}' +
    '.mo-up-row{display:inline-flex;align-items:center;gap:6px}' +
    '.mo-up b{font-variant-numeric:tabular-nums}' +
    '.mo-up small{font-size:10.5px;font-weight:600;opacity:.85}' +
    '.mo-bar{display:block;align-self:stretch;min-width:96px;height:5px;margin:3px 0 1px;border-radius:3px;background:rgba(255,255,255,.25);overflow:hidden}' +
    '.mo-bar>span{display:block;height:100%;width:0;border-radius:3px;background:#8fe0c4;transition:width .25s ease}' +
    '[data-mo-state=error] .mo-up{border-radius:12px;background:#b3261e}' +
    '[data-mo-state=done] .mo-up{left:auto;right:6px;top:6px;transform:none;width:22px;height:22px;padding:0;justify-content:center;background:#365E55;border:2px solid #fff}' +
    '[data-mo-state=done] .mo-up svg{width:12px;height:12px;fill:none;stroke:#fff;stroke-width:3.2;stroke-linecap:round;stroke-linejoin:round}' +
    '[data-mo-own-tick][data-mo-state=done] .mo-up{display:none}' +
    '@keyframes mo-spin{to{transform:rotate(360deg)}}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var boxOf = function (input) {
    return input.closest('label') || (input.id && document.querySelector('label[for="' + input.id + '"]'));
  };
  var setState = function (input, state) {
    var box = boxOf(input);
    if (!box) return;
    var host = box.querySelector('[data-mo-badge]') || box;
    var tag = box.querySelector('.mo-up');
    if (!state) { box.removeAttribute('data-mo-state'); if (tag) tag.remove(); return; }
    if (!tag) { tag = document.createElement('span'); tag.className = 'mo-up'; tag.setAttribute('aria-live', 'polite'); host.appendChild(tag); }
    box.setAttribute('data-mo-state', state);
    tag.innerHTML = state === 'uploading' ? '<span class="mo-up-row"><i></i>Uploading <b>0%</b></span><span class="mo-bar"><span></span></span><small>You can keep going</small>'
      : state === 'error' ? 'Upload failed, tap to retry'
      : '<svg viewBox="0 0 24 24" aria-label="Uploaded"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  };
  // the real upload progress: the bar fills and the label counts up to 100%
  var showProgress = function (input, p) {
    var box = boxOf(input);
    if (!box || box.getAttribute('data-mo-state') !== 'uploading') return;
    var pct = Math.round(p * 100) + '%';
    var b = box.querySelector('.mo-up b'), fill = box.querySelector('.mo-bar > span');
    if (b) b.textContent = pct;
    if (fill) fill.style.width = pct;
  };
  var go = function (input, f) {
    setState(input, 'uploading');
    return window.MomavoUpload.start(f, function (p) { if (input.files[0] === f) showProgress(input, p); }).then(function (url) {
      if (input.files[0] === f) setState(input, 'done');
      return url;
    }, function (e) {
      if (input.files[0] === f) setState(input, 'error');
      throw e;
    });
  };

  // a tiny square copy (96 px, a few KB) for the cart and order pages, so a 20-player cart does not
  // load 20 full-size photos. It goes in a hidden "_<property> thumb" line property.
  var thumbs = new WeakMap();
  var thumbOf = function (f) {
    if (!thumbs.has(f)) {
      thumbs.set(f, (window.createImageBitmap ? createImageBitmap(f, { imageOrientation: 'from-image' }) : Promise.reject())
        .then(function (bmp) {
          var S = 96, m = Math.min(bmp.width, bmp.height), c = document.createElement('canvas');
          c.width = c.height = S;
          c.getContext('2d').drawImage(bmp, (bmp.width - m) / 2, (bmp.height - m) / 2, m, m, 0, 0, S, S);
          return new Promise(function (res) { c.toBlob(res, 'image/jpeg', 0.8); });
        })
        .then(function (b) { return b ? window.MomavoUpload.start(new File([b], 'thumb.jpg', { type: 'image/jpeg' })) : null; })
        .catch(function () { return null; }));
    }
    return thumbs.get(f);
  };
  // thumbnail URLs for these inputs (null where none); never holds up Add to cart for more than 3 s
  var thumbUrls = function (inputs) {
    return Promise.all(inputs.map(function (input) {
      return Promise.race([thumbOf(input.files[0]), new Promise(function (res) { setTimeout(res, 3000, null); })]);
    }));
  };
  var thumbKey = function (prop) { return '_' + prop + ' thumb'; };

  // upload on pick (runs after the page's own checks, which clear a wrong file)
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('input[type=file][data-mo-photo]')) return;
    var f = input.files && input.files[0];
    if (!f) { setState(input, null); return; }
    go(input, f).catch(function () {});
    thumbOf(f);
  });
  // a photo picked before this script loaded (it loads with defer): start it now
  [].forEach.call(document.querySelectorAll('input[type=file][data-mo-photo]'), function (input) {
    var f = input.files && input.files[0];
    if (f && !window.MomavoUpload.get(f)) { go(input, f).catch(function () {}); thumbOf(f); }
  });
  // a failed upload: tapping its box tries again instead of opening the photo picker
  document.addEventListener('click', function (e) {
    var box = e.target.closest && e.target.closest('[data-mo-state=error]');
    if (!box) return;
    var input = box.querySelector('input[type=file][data-mo-photo]') || (box.htmlFor && document.getElementById(box.htmlFor));
    var f = input && input.files && input.files[0];
    if (!f) return;
    e.preventDefault();
    go(input, f).catch(function () {});
  }, true);

  // waits for every photo; a failed one is tried again (start() also retries once inside)
  var finish = function (inputs, onWait) {
    var waiting = inputs.some(function (input) {
      var j = window.MomavoUpload.get(input.files[0]);
      return !j || j.state !== 'done';
    });
    if (waiting && onWait) onWait();
    return Promise.all(inputs.map(function (input) {
      var j = window.MomavoUpload.get(input.files[0]);
      if (j && j.state === 'done') return j.url;
      return go(input, input.files[0]).catch(function (e) { e.input = input; throw e; });
    }));
  };

  var cartEl = function () {
    return document.querySelector('cart-notification') || document.querySelector('momavo-cart-drawer') || document.querySelector('cart-drawer');
  };
  var add = function (items, cart) {
    var body = { items: items };
    if (cart) { body.sections = cart.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = location.pathname; }
    var t = performance.now();
    return fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        console.info('[momavo] add to cart', items.length + (items.length === 1 ? ' line' : ' lines'), Math.round(performance.now() - t) + ' ms');
        if (!r.ok || j.status) throw new Error(j.description || j.message || 'Error');
        return j;
      });
    });
  };

  // the single-light Add to cart: photo URLs as text properties, one JSON call, then the cart drawer
  var single = function (form) {
    var pf = form.closest('product-form');
    var btn = form.querySelector('[type=submit]');
    if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
    var item = { id: form.querySelector('[name=id]').value, quantity: 1, properties: {} };
    new FormData(form).forEach(function (v, key) {
      if (key === 'quantity') item.quantity = parseInt(v, 10) || 1;
      var m = key.match(/^properties\[(.+)\]$/);
      if (m && typeof v === 'string' && v !== '') item.properties[m[1]] = v;
    });
    var photos = [].filter.call(form.querySelectorAll('input[type=file][data-mo-photo]'), function (i) { return !i.disabled && i.files && i.files[0]; });
    var label = btn.querySelector('span'), keep = label ? label.innerHTML : '';
    var spin = pf && pf.querySelector('.loading__spinner');
    if (pf && pf.handleErrorMessage) pf.handleErrorMessage();
    btn.setAttribute('aria-disabled', 'true');
    var cart = cartEl();
    var done = function () {
      btn.removeAttribute('aria-disabled'); btn.classList.remove('loading');
      if (label) label.innerHTML = keep;
      if (spin) spin.classList.add('hidden');
    };
    finish(photos, function () { if (label) label.textContent = 'Finishing photo upload…'; })
      .then(function (urls) {
        photos.forEach(function (input, k) { item.properties[input.getAttribute('data-mo-prop')] = urls[k]; });
        return thumbUrls(photos);
      })
      .then(function (small) {
        photos.forEach(function (input, k) { if (small[k]) item.properties[thumbKey(input.getAttribute('data-mo-prop'))] = small[k]; });
        if (label) label.innerHTML = keep;
        btn.classList.add('loading');
        if (spin) spin.classList.remove('hidden');
        if (cart && cart.setActiveElement) cart.setActiveElement(document.activeElement);
        return add([item], cart);
      })
      .then(function (r) {
        done();
        if (!cart) { window.location = window.routes.cart_url; return; }
        if (window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: item.id, cartData: r });
        cart.renderContents(r);
        cart.classList.remove('is-empty');
      })
      .catch(function (e) {
        done();
        var msg = e.input ? 'A photo could not upload. Please tap it to try again.' : e.message;
        if (e.input) { var b = boxOf(e.input); if (b) b.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        if (pf && pf.handleErrorMessage) pf.handleErrorMessage(msg); else alert(msg);
      });
  };

  window.MomavoPhotoCart = { single: single, finish: finish, thumbs: thumbUrls, thumbKey: thumbKey, add: add, cart: cartEl, state: setState };
})();
